import { isMobileBrowser } from '../base/environment/utils';
import { shouldDisplayTileView } from '../video-layout/functions.any';
/**
 * 是否处于手机端「屏幕共享聚焦」布局。
 * 条件：移动浏览器 + 存在远端屏幕共享 + 非画廊视图。
 *
 * @param {IReduxState} state - Redux 状态。
 * @returns {boolean}
 */
export function isMobileScreenshareFocusMode(state) {
    if (!isMobileBrowser()) {
        return false;
    }
    if (shouldDisplayTileView(state)) {
        return false;
    }
    const { remoteScreenShares } = state['features/video-layout'];
    return Boolean(remoteScreenShares?.length);
}
